<template>
    <div>
        <Head title="ApiLead" />
        <h1 class="mb-8 text-3xl font-bold">Api Leads</h1>
        <div class="bg-white rounded-md shadow overflow-x-auto">
            <table class="w-full whitespace-nowrap">
                <tr class="text-left font-bold">
                    <th class="pb-4 pt-6 px-6">ID</th>
                    <th class="pb-4 pt-6 px-6">Firstname</th>
                    <th class="pb-4 pt-6 px-6">Lastname</th>
                    <th class="pb-4 pt-6 px-6">Email</th>
                    <th class="pb-4 pt-6 px-6">Phone</th>
                    <th class="pb-4 pt-6 px-6">ZIP</th>
                    <th class="pb-4 pt-6 px-6">City</th>
                    <th class="pb-4 pt-6 px-6">Street</th>
                    <th class="pb-4 pt-6 px-6">House</th>
                    <th class="pb-4 pt-6 px-6">Referer</th>
                    <th class="pb-4 pt-6 px-6">Affiliate</th>
                    <th class="pb-4 pt-6 px-6">UTM Source</th>
                    <th class="pb-4 pt-6 px-6">UTM Content</th>
                    <th class="pb-4 pt-6 px-6">UTM Campaign</th>
                    <th class="pb-4 pt-6 px-6">UTM Keyword</th>
                    <th class="pb-4 pt-6 px-6">Special Mark</th>
                    <th class="pb-4 pt-6 px-6">Status</th>
                    <th class="pb-4 pt-6 px-6">Callback Link</th>
                    <th class="pb-4 pt-6 px-6">Callback Response</th>
                    <th class="pb-4 pt-6 px-6">Mgmt Callback</th>
                    <th class="pb-4 pt-6 px-6">Created At</th>
                </tr>

                <tr v-for="apilead in apiLeads" :key="apilead.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
                    <td class="border-t">
<!--                        <Link class="flex items-center px-6 py-4 focus:text-indigo-500" :href="`/api-leads/${apilead.id}/edit`">-->
                        <Link class="flex items-center px-6 py-4 focus:text-indigo-500" :href="`#`">
                            {{ apilead.id }}
                        </Link>
                    </td>
                    <td class="border-t">
                        <Link class="flex items-center px-6 py-4 focus:text-indigo-500" :href="`#`">
                            {{ apilead.firstname }}
                        </Link>
                    </td>
                    <td class="border-t">
                        <Link class="flex items-center px-6 py-4 focus:text-indigo-500" :href="`#`">
                            {{ apilead.lastname }}
                        </Link>
                    </td>
                    <td class="border-t">
                        <Link class="flex items-center px-6 py-4 focus:text-indigo-500" :href="`#`">
                            {{ apilead.email }}
                        </Link>
                    </td>
                    <td class="border-t">
                        <Link class="flex items-center px-6 py-4 focus:text-indigo-500" :href="`#`">
                            {{ apilead.phone }}
                        </Link>
                    </td>
                    <td class="border-t">
                        <Link class="flex items-center px-6 py-4 focus:text-indigo-500" :href="`#`">
                            {{ apilead.zip }}
                        </Link>
                    </td>
                    <td class="border-t">
                        <Link class="flex items-center px-6 py-4 focus:text-indigo-500" :href="`#`">
                            {{ apilead.city }}
                        </Link>
                    </td>
                    <td class="border-t">
                        <Link class="flex items-center px-6 py-4 focus:text-indigo-500" :href="`#`">
                            {{ apilead.street }}
                        </Link>
                    </td>
                    <td class="border-t">
                        <Link class="flex items-center px-6 py-4 focus:text-indigo-500" :href="`#`">
                            {{ apilead.house }}
                        </Link>
                    </td>
                    <td class="border-t">
                        <Link class="flex items-center px-6 py-4 focus:text-indigo-500" :href="`#`">
                            {{ apilead.referer }}
                        </Link>
                    </td>
                    <td class="border-t">
                        <Link class="flex items-center px-6 py-4 focus:text-indigo-500" :href="`#`">
                            {{ apilead.affiliate }}
                        </Link>
                    </td>
                    <td class="border-t">
                        <Link class="flex items-center px-6 py-4 focus:text-indigo-500" :href="`#`">
                            {{ apilead.utm_source }}
                        </Link>
                    </td>
                    <td class="border-t">
                        <Link class="flex items-center px-6 py-4 focus:text-indigo-500" :href="`#`">
                            {{ apilead.utm_content }}
                        </Link>
                    </td>
                    <td class="border-t">
                        <Link class="flex items-center px-6 py-4 focus:text-indigo-500" :href="`#`">
                            {{ apilead.utm_campaign }}
                        </Link>
                    </td>
                    <td class="border-t">
                        <Link class="flex items-center px-6 py-4 focus:text-indigo-500" :href="`#`">
                            {{ apilead.utm_keyword }}
                        </Link>
                    </td>
                    <td class="border-t">
                        <Link class="flex items-center px-6 py-4 focus:text-indigo-500" :href="`#`">
                            {{ apilead.special_mark }}
                        </Link>
                    </td>
                    <td class="border-t">
                        <Link class="flex items-center px-6 py-4 focus:text-indigo-500" :href="`#`">
                            {{ apilead.status }}
                        </Link>
                    </td>
                    <td class="border-t">
                        <Link class="flex items-center px-6 py-4 focus:text-indigo-500" :href="`#`">
                            {{ apilead.callback_link }}
                        </Link>
                    </td>
                    <td class="border-t">
                        <Link class="flex items-center px-6 py-4 focus:text-indigo-500" :href="`#`">
                            {{ apilead.callback_response }}
                        </Link>
                    </td>
                    <td class="border-t">
                        <Link class="flex items-center px-6 py-4 focus:text-indigo-500" :href="`#`">
                            {{ apilead.mgmt_callback }}
                        </Link>
                    </td>
                    <td class="border-t">
                        <Link class="flex items-center px-6 py-4 focus:text-indigo-500" :href="`#`">
                            {{ apilead.created_at }}
                        </Link>
                    </td>
                </tr>
                <tr v-if="apiLeads.length === 0">
                    <td class="px-6 py-4 border-t" colspan="4">No Api Leads found.</td>
                </tr>
            </table>
        </div>
    </div>
</template>

<script>
import { Head, Link } from '@inertiajs/vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import SearchInput from '@/Shared/SearchInput'

export default {
    components: {
        Head,
        Icon,
        Link,
        SearchInput,
    },
    layout: Layout,
    props: {
        filters: Object,
        apiLeads: Array,
    },
    data() {
        return {
            form: {
                search: this.filters.search
            },
        }
    },
    watch: {
        form: {
            deep: true,
            handler: throttle(function () {
                this.$inertia.get('/api-leads', pickBy(this.form), { preserveState: true })
            }, 150),
        },
    },
    methods: {
        reset() {
            this.form = mapValues(this.form, () => null)
        },
    },
}
</script>
